export default __webpack_public_path__ + "static/covington-2f51b1fbf0ea616af380154cb07299ee.jpg";